module.exports = __webpack_public_path__ + "img/maschera_nuvole_nera.c44cc047.png";